import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './verifyOtpPage.css';
import '../../components/common/style.css';
import '../../components/common/responsive.css';
import { useUser } from '../../contexts/userContext';
import selsmartLogo from '../../assets/images/selsmart.png';
import '../home/homePage.css';
import { RESEND_OTP_TIMEOUT } from '../../components/common/constant';

const VerifyOtp = () => {
  const [otp, setOtp] = useState(new Array(6).fill(''));
  const [error, setError] = useState('');
  const [seconds, setSeconds] = useState(120);
  const [userNumber, setUserNumber] = useState<string | null>('');
  const [isDisabled, setIsDisabled] = useState(true); // Disable resend button initially
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(true); // Disable Verify OTP button
  const location = useLocation();
  const userId = location.state?.user_id;
  let returnUrl = location.state?.returnUrl;
  const slug = location.state?.slug;
  const product = location.state?.product;
  const userInfo = location.state?.user;
  const cartId = location.state?.cart_id;
  const session_code = location.state?.session_code;
  const urlLoginPage = location.state?.urlLoginPage;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const { auth_token ,setUserId,fetchCsrfToken} = useUser();
  const nameInputRef = useRef<Array<HTMLInputElement | null>>([]);
  let utmQuery = location.state?.utmQuery;
  utmQuery = utmQuery || "";

  useEffect(() => {
    //console.log("verify page utm-------", utmQuery);
    nameInputRef.current[0]?.focus();
  }, []);

  // let mobile_number;

  useEffect(() => {
    nameInputRef.current[0]?.focus();
    const savedMobileNumber = JSON.parse(sessionStorage.getItem("mobileNumber") || "{}");
    if (savedMobileNumber) {
      setUserNumber
    (savedMobileNumber)
      //console.log("Saved Data: ", savedMobileNumber);
    }else(
      setUserNumber('95xxxxxx89')
    )
  }, []);
 
  const handleChange = (element: HTMLInputElement, index: number) => {
    const value = element.value.replace(/\D/g, ''); // Allow only digits

    if (value.length === 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Enable "Verify OTP" button only when all 6 digits are filled
      const otpValue = newOtp.join('');

      setIsVerifyDisabled(otpValue.length !== 6);

      // Focus the next input if the current one is filled and it's not the last input
      if (index < otp.length - 1) {
        nameInputRef.current[index + 1]?.focus();
      }

      // Automatically verify OTP if all 6 digits are filled
      if (otpValue.length === 6) {
        //console.log("top============", otpValue, otpValue.length)
        handleOtpSubmit(otpValue); // Trigger OTP submit automatically
      }

    } else if (value === '') {
      // Handle backspace case by clearing the input
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      setIsVerifyDisabled(true); // Disable Verify button on backspace
    }
  };

  // Handle backspace key
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        nameInputRef.current[index - 1]?.focus();
      }
      const newOtp = [...otp];
      newOtp[index] = ''; // Clear current input
      setOtp(newOtp);
      setIsVerifyDisabled(true); // Disable Verify button on backspace
    }
  };

  // Handle resend OTP
  const handleResendOtp = async () => {
    try {
      setIsDisabled(true);
      setSeconds(RESEND_OTP_TIMEOUT);
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/resend-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': `${auth_token}`,
          'X-CSRF-Token': csrfToken,
          
        },
        credentials: "include",
        body: JSON.stringify({ userInfo }),
        
      });

      if (!response.ok) {
        throw new Error('Failed to resend OTP');
      }

      //console.log('OTP resent successfully');
      nameInputRef.current[0]?.focus();
      // Reset timer
      // Disable resend button
    } catch (error) {
      //console.error('Error resending OTP:', error);
      setError('Failed to resend OTP');
    }
  };

  const handleResendExpireOtp = async () => {
    try {
      // setIsDisabled(true);
      // setSeconds(RESEND_OTP_TIMEOUT);
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/resend-otp-expire`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': `${auth_token}`,
          'X-CSRF-Token': csrfToken,
          
        },
        credentials: "include",
        body: JSON.stringify({ userInfo }),
        
      });

      if (!response.ok) {
        throw new Error('Failed to resend OTP');
      }

      //console.log('OTP resent successfully');
      // Reset timer
      // Disable resend button
    } catch (error) {
      //console.error('Error resending OTP:', error);
      setError('Failed to resend OTP');
    }
  };

  // Timer countdown effect
  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;

    if (isDisabled && seconds > 0) {
      timer = setInterval(() => {
        setSeconds(prev => prev - 1);
      }, 1000);
    }

    if (seconds <= 0) {
      setIsDisabled(false); // Enable resend button
      if (timer) {
        clearInterval(timer);
      }
      handleResendExpireOtp()
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [seconds, isDisabled]);

  const handleOtpSubmit = async (otpValue: any) => {
    // Join the OTP array into a single string
    //console.log('OTP Value:', otpValue); // Debugging output

    if (otpValue.length !== 6) {
      setError('Please enter a 6-digit OTP');
      return;
    }

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v1/verify-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ userId, otp: otpValue }),
        
      });

      const data = await response.json();

      if (data.data.success) {
        localStorage.setItem('isLoggedIn', 'true'); // Set login state


        if (returnUrl === `${slug}`) {
          returnUrl = `${slug}`
        }
        sessionStorage.removeItem("mobileNumber");
        setUserId(userId);
        navigate(returnUrl || "/", {
          state: { user_id: userId, returnUrl, product, cart_id: cartId, session_code: session_code, utmQuery }
        });
        window.scrollTo({ top: 0, behavior: 'smooth' })

      } else {
        setOtp(new Array(6).fill('')); // Reset OTP fields
        setError(data.error?.message || 'Invalid OTP');
        nameInputRef.current[0]?.focus(); // Focus the first input
      }
    } catch (err: any) {
      setOtp(new Array(6).fill('')); // Reset OTP fields
      setError(err.message || 'An unexpected error occurred');
    }
  };

  const handleEditButton = () => {
    if (urlLoginPage == '/login') {
      navigate('/login')
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  };

  const convert_resend_button_timer = () => {
    const minutes = Math.floor(seconds / 60);
    const secondsRemaining = seconds % 60;
    return `${minutes.toString().padStart(2, '0')} m : ${secondsRemaining.toString().padStart(2, '0')} s`;
  };

  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'verify_otp_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json"
      
            },
            credentials: "include",
            mode:"cors"                       
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-white- login_screen">
        <div className="container-fluid">
          {/* <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
          <div
            className="collapse- navbar-collapse-"
            id="navbarSupportedContent-"
          >
            <ul className="navbar-nav mb-2- mb-lg-0 ms-auto">
              <li className="nav-item">
                <a className="navbar-brand" href="/">
                  <img src={selsmartLogo} alt="logo" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="container-fluid sign_in">
        <div className="row">
          <div className="col-6 green_bg position-relative">
            <div className="right-side">
              {/* <!-- <img src="images/selsmart_logo.png" alt="Selsmart Logo" class="selsmart-logo"> --> */}
              <h1>
                Welcome to <br />
                <span className="selsmart-heading">Selsmart</span>
              </h1>
              <p className="welcome-text">
                Sell your used
                <br className="view" /> electronic appliances in{" "}
                <br className="view" />a smart way with us!
              </p>
              <hr className="white-line" />
            </div>
          </div>
          <div className="white_bg_right col-6">
            <div className="left-side">
              <div className="verify-otp-content- form-container vryfi_OTP">
                <h2>Verify OTP</h2>
                <p>
                  Please enter the six-digit OTP sent to <br />  (+91)-{
    userNumber && !isNaN(Number(userNumber)) && userNumber.length === 10
      ? `${userNumber.slice(0, 2)}xxxxxx${userNumber.slice(-2)}`
      : '95-xxxxxx-89'
  }
                  {urlLoginPage === '/login' ? (
                    <a
                      href="/login" // To make it appear clickable
                      className="ediT"
                      onClick={handleEditButton}
                      style={{ cursor: 'pointer', textDecoration: 'none' }} // Add some style
                    >
                      Edit
                    </a>
                  ) : null}
                </p>
                <div className="verify-rep- otp-input-container flex-define">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="number"
                      className="otp-input"
                      maxLength={1}
                      value={digit}
                      placeholder="_"
                      ref={(el) => (nameInputRef.current[index] = el)}
                      onChange={(e) => handleChange(e.target, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onFocus={(e) => e.target.select()}
                    />
                  ))}
                </div>
                <div className="verify_Otp_btn_wrap">
                  <div className="social-buttons">
                    <button
                      className="btn btn-secondary- btn-outline-success re_send_otp"
                      onClick={handleResendOtp}
                      style={{
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        // opacity: isDisabled ? 0.5 : 1,
                        display: isDisabled ? "none" : "block",
                      }}
                    >
                      Resend OTP
                    </button>
                    <button
                      className="btn btn-success verify_Otp"
                      onClick={handleOtpSubmit}
                      disabled
                      style={{ display: 'none' }} // Hide the button as it's not needed
                    >
                      Verify OTP
                    </button>
                  </div>
                </div>

                <p className="trouble_otp">Trouble in getting OTP?</p>
                <p className="chk_mobile_no">
                  Make sure you entered the correct mobile number.
                </p>

                <div className="otptext">
                  {/* <p className="info">An OTP has been sent to your Mobile No.</p> */}
                  <p className="request">
                    {isDisabled
                      ? `Request new OTP in ${convert_resend_button_timer()}`
                      : "You can request a new OTP"}
                  </p>
                </div>
                {/* {!isDisabled && (
                    <div
                      className="linkResendotp"
                      onClick={handleResendOtp}
                      style={{
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.5 : 1,
                      }}
                    >
                      RESEND OTP
                    </div>
                  )} */}
                {error && <p className="error-verify-fail">{error}</p>}
              </div>
            </div>
            <div className="copy_right">© {currentYear} All rights reserved.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
